var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"hidden lg:block w-full",attrs:{"fill":"none","viewBox":"0 0 1920 4454"}},[_c('passengers-how-it-works-line-02'),_vm._v(" "),_c('passengers-how-it-works-line-03'),_vm._v(" "),_c('passengers-how-it-works-line-01')],1)}
var staticRenderFns = []

export { render, staticRenderFns }